import useReduxAction from '@hooks/useReduxAction'
import useActivityLogTypes from '@hooks/useActivityLogTypes'
import useServiceJobStatuses from '@hooks/useServiceJobStatuses'
import useServiceJobChecklistItemTypes from '@hooks/useServiceJobChecklistItemTypes'

const BackOffice = (props) => {
  const { children } = props

  useReduxAction('emailReplacements', 'loadEmailReplacements', {})
  useReduxAction('serviceCategories', 'loadServiceCategories', {})
  useReduxAction('wordReplacements', 'loadWordReplacements', {})
  useReduxAction('zones', 'loadZones', {})

  useReduxAction('employmentTypesV4', 'loadEmploymentTypesV4', {})
  useReduxAction('userFlagsV4', 'loadUserFlagsV4', {})
  useReduxAction('userRolesV4', 'loadUserRolesV4', {})
  useReduxAction('userRoles', 'loadUserRoles', {})
  useReduxAction('providerFlagsV4', 'loadProviderFlagsV4', {})
  useReduxAction('serviceTypesV4', 'loadServiceTypesV4', {})
  useReduxAction('statesV4', 'loadStatesV4', {})
  useReduxAction('zoneFlagsV4', 'loadZoneFlagsV4', {})
  useReduxAction('clientFlagsV4', 'loadClientFlagsV4', {})

  useActivityLogTypes({ performHttpRequests: true })
  useServiceJobStatuses({ performHttpRequests: true })
  useServiceJobChecklistItemTypes({ performHttpRequests: true })
  

  return children
}

export default BackOffice
